import { faSquare } from '@fortawesome/pro-solid-svg-icons';
import { Chip, ChipStatus } from 'framework/chip';
import { CHIP_VARIANT } from 'framework/chip/enums';

export default () => {
  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', margin: '20px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', margin: 10, gap: 16 }}>
          <ChipStatus label="Green" variant={CHIP_VARIANT.GREEN} />
          <ChipStatus label="Blue" variant={CHIP_VARIANT.BLUE} />
          <ChipStatus label="Red" variant={CHIP_VARIANT.RED} />
          <ChipStatus label="Yellow" variant={CHIP_VARIANT.YELLOW} />
          <ChipStatus label="Orange" variant={CHIP_VARIANT.ORANGE} />
          <ChipStatus label="Purple" variant={CHIP_VARIANT.PURPLE} />
          <ChipStatus label="Aqua" variant={CHIP_VARIANT.AQUA} />
          <ChipStatus label="Navy" variant={CHIP_VARIANT.NAVY} />
          <ChipStatus label="Light" variant={CHIP_VARIANT.LIGHT} />
          <ChipStatus label="Livid" variant={CHIP_VARIANT.LIVID} />
          <ChipStatus label="Pink" variant={CHIP_VARIANT.PINK} />
          <ChipStatus label="Dark" variant={CHIP_VARIANT.DARK} />
          <ChipStatus label="Platinum" variant={CHIP_VARIANT.PLATINUM} />
          <ChipStatus label="Teal" variant={CHIP_VARIANT.TEAL} />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', margin: 10, gap: 16 }}>
          <Chip label="Green" icon={faSquare} variant={CHIP_VARIANT.GREEN} clear />
          <Chip label="Blue" icon={faSquare} variant={CHIP_VARIANT.BLUE} clear />
          <Chip label="Red" icon={faSquare} variant={CHIP_VARIANT.RED} clear />
          <Chip label="Yellow" icon={faSquare} variant={CHIP_VARIANT.YELLOW} clear />
          <Chip label="Orange" icon={faSquare} variant={CHIP_VARIANT.ORANGE} clear />
          <Chip label="Purple" icon={faSquare} variant={CHIP_VARIANT.PURPLE} clear />
          <Chip label="Aqua" icon={faSquare} variant={CHIP_VARIANT.AQUA} clear />
          <Chip label="Navy" icon={faSquare} variant={CHIP_VARIANT.NAVY} clear />
          <Chip label="Light" icon={faSquare} variant={CHIP_VARIANT.LIGHT} clear />
          <Chip label="Livid" icon={faSquare} variant={CHIP_VARIANT.LIVID} clear />
          <Chip label="Pink" icon={faSquare} variant={CHIP_VARIANT.PINK} clear />
          <Chip label="Dark" icon={faSquare} variant={CHIP_VARIANT.DARK} clear />
          <Chip label="Platinum" icon={faSquare} variant={CHIP_VARIANT.PLATINUM} clear />
          <Chip label="Teal" icon={faSquare} variant={CHIP_VARIANT.TEAL} clear />
        </div>
      </div>
    </div>
  );
};
